import React, { useEffect, useRef, useState } from "react";
import { Layout, Button, Dropdown, Popover, theme } from "antd";
import {UserOutlined} from '@ant-design/icons'
import MenuComponent from "../components/Menu";
import HeaderSearchComponent from "../components/HeaderSearch";
import {ReactComponent as UserIcon} from "../assets/icon/Home/用户.svg";

import { Outlet, useLocation, useNavigate } from "react-router-dom";
const { Header, Content, Footer } = Layout;

const MainLayOut = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [pathname, setPathname] = useState("");
  useEffect(() => {
    setPathname(location.pathname);
  }, [location]);
  const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();
  const [TokenData, setTokenData] = useState(
    sessionStorage.getItem("token")
      ? sessionStorage.getItem("token")
      : "no"
  );
  const items = [
   {

   },
    {
      key: "2",
      label: (
        <div>
          <p>
            {
              sessionStorage.getItem("username") 
            }
          </p>
        <p
          onClick={() => {
            sessionStorage.removeItem("token");
            setTokenData("no");
          }}
          style={{
            display:"flex",
            alignItems:"center",
            justifyContent:"center"
          }}
        >
          Login out
        </p>
        </div>
      ),
    },
  ];
  const popoverContent = (
    <div
      style={{
        width: "200px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <p style={{ margin: "5px 0" }}>UserName: {sessionStorage.getItem('username')}</p>
    
      
      <Button
        danger
        onClick={()=>{
          sessionStorage.removeItem("token");
            setTokenData("no");
        }}
        style={{ width: "100px", margin: "5px 0" }}
      >
        Logout
      </Button>
    </div>
  );
  const [width, setWidth] = useState(window.innerWidth);
  const widthRef = useRef(width);

  useEffect(() => {
    const handleResize = () => {
      widthRef.current = window.innerWidth;
      setWidth(widthRef.current);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <Layout style={{ height: "100vh",  }}>
   
      <Header
        style={{
          width: "100%",
          height: "12.5vh", // 设置高度为视口高度的10%
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          background: "#BDF7C1",
        }}
      >
        <div
          style={{
            width: "15%",
            height: "100%",
            background: "#BDF7C1",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
          }}
          onClick={() => {
            navigate("/lotus/home/");
            sessionStorage.setItem("MenuKey", 1);
          }}
        >
          <img
            src={require("../assets/image/Logo.png")}
            style={{ width: "38%", borderRadius: "50%", marginRight: "10px" }}
            alt=""
          />
         
        </div>
        <div
          style={{
            width: "80%",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            color: "black",
          }}
        >
          <MenuComponent />
        </div>
        <div style={{
          width:"10%",
          height:"100%",
          display:"flex",
          justifyContent:"center",
          alignItems:"center"
        }}>
          {/* {
            TokenData == "no"?<Button
            onClick={()=>{
              navigate('/login')
            }}
            style={{
              display:"flex",
              alignItems:"center",
              justifyContent:"center",
             
            }}
            >Login</Button>:     <Popover
            content={popoverContent}
           
            trigger="hover"
          >
           <UserOutlined  style={{fontSize:"25px"}} />
          </Popover>
          } */}
      
         
        </div>
      </Header>
      <Content
        style={{
          background: "#fff",
          overflow: pathname == "/lotus/tutorial/" ? "hidden" : "auto",
        }}
      >
        <Outlet />
      </Content>
    </Layout>
  );
};
export default MainLayOut;
